import { updateAlarmPoint } from '../../../api/alarmPoint'
import { activateAlarmPanel } from '../../../api/alarmPanel'

export const TRIGGER_STATE = {
  IDLE: 'idle',
  VALIDATING: 'validating',
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  FAILED: 'failed',
}

export class AlarmTriggerValidationError extends Error {
  constructor(message = 'Invalid alarm trigger payload') {
    super(message)
    this.name = 'AlarmTriggerValidationError'
  }
}

export class AlarmTriggerPartialSuccessError extends Error {
  constructor(cause) {
    super('Alarm was activated, but alarm point update failed')
    this.name = 'AlarmTriggerPartialSuccessError'
    this.cause = cause
    this.partialSuccess = true
  }
}

export function buildAlarmTriggerPayload(triggerBody) {
  if (!triggerBody?.tempAlarmPoint || !triggerBody?.button?.id) {
    throw new AlarmTriggerValidationError()
  }

  const instructionFiles = Array.isArray(triggerBody.instructionFiles)
    ? [...triggerBody.instructionFiles]
    : []

  return {
    activationPayload: {
      ...triggerBody,
      button: {...triggerBody.button},
      instructionFiles,
      tempAlarmPoint: {...triggerBody.tempAlarmPoint},
    },
    alarmPointPayload: {
      ...triggerBody.tempAlarmPoint,
      instructionFiles,
    },
  }
}

export async function submitAlarmPanelTrigger(triggerBody, api = {}) {
  const activate = api.activateAlarmPanel ?? activateAlarmPanel
  const update = api.updateAlarmPoint ?? updateAlarmPoint
  const {activationPayload, alarmPointPayload} = buildAlarmTriggerPayload(triggerBody)

  await activate(activationPayload)

  try {
    await update(alarmPointPayload)
  } catch (error) {
    throw new AlarmTriggerPartialSuccessError(error)
  }
}
